export class ExperimentExcerpt{
  constructor(imgSrc,text) {
    this.imgSrc = imgSrc;
    this.caption = text;
  }
}